import { render, staticRenderFns } from "./monitor-center-alert-edit.vue?vue&type=template&id=da090bcc&scoped=true"
import script from "./monitor-center-alert-edit.vue?vue&type=script&lang=js"
export * from "./monitor-center-alert-edit.vue?vue&type=script&lang=js"
import style0 from "./monitor-center-alert-edit.vue?vue&type=style&index=0&id=da090bcc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da090bcc",
  null
  
)

export default component.exports